import { createContext } from "react";
import { Theme } from "@/payload-types";

export const ThemeContext = createContext<Theme>( {id: ''} );
